<div *ngIf="isShow" class="btn-div blue-btn-div pointer" [class.ig-in-trip]="isInAnyTrip" (click)="openTripMenu()"
     #menuTrigger="matMenuTrigger"
     [style.background]="bgColor"
     [matMenuTriggerFor]="actionMenu" role="button">
    <span class="add-text">{{isInAnyTrip ? inTripText : addToTripText}}</span>
<!--    <ng-content select="[text]"></ng-content>-->
</div>


<mat-menu [yPosition]="'above'" #actionMenu="matMenu" (closed)="exitAddingNewTrip($event)">
    <button mat-menu-item *ngFor="let trip of trips;let i = index" class="trip-title-btn"
            (click)="addOrRemoveFromTrip($event, i)"
            [style.background]="bgColor"
            matTooltip="{{!inTripStatus[i]?'Add to':'Remove from'}} {{trip.title}}">

        <mat-icon tip *ngIf="isAddingSuccess[i]">done</mat-icon>
        <span trip *ngIf="!isAddingSuccess[i]">{{!inTripStatus[i]?'Add to':'Remove from'}} "{{trip.title}}"</span>
        <span trip *ngIf="isAddingSuccess[i]">{{!inTripStatus[i]?'Added to':'Removed from'}} "{{trip.title}}"</span>
    </button>
    <ig-button *ngIf="!isAddingNewTrip"
               class="add-trip-btn" [size]="'md'"
               (trigger)="addNewTrip()">
        Create a new trip
    </ig-button>
    <form ngForm="tripFormGroup" class="trip-title-form" *ngIf="isAddingNewTrip">
        <ig-mat-field #tripTitle
                      (onInputFocus)="newTripFieldFocus($event)"
                      label="Enter your trip title"
                      [(ngModel)]="newTripTitle"
                      [isRequired]="true"
                      (onEnterPress)="saveNewTrip()"
                      [formControl]="tripFormGroup.get('tripTitle')"
        ></ig-mat-field>
        <ig-button *ngIf="newTripTitle" [size]="'md'" class="" (trigger)="saveNewTrip()">
            create trip
        </ig-button>
    </form>
</mat-menu>




// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/trip/add.to.trip.menu/visitor.trip.add.to.trip.menu.component.html